<template>
  <div style="width: 100%;">
    <el-select @change="change" v-model="value" placeholder="请选择" style="width: 100%">
      <el-option
        v-for="(item,index) in options"
        :key="item.id"
        :label="item.name"
        :value="index"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
	name: "SMarks",
  components: {},
  props: {
    modelValue: {
      type: String, // 根据你传递的类型，修改这里的类型
      default: "",
    },
	typelei:{
		type: Number, // 根据你传递的类型，修改这里的类型
		default: 0
	}
  },
  data() {
    return {
      value: this.modelValue,
      options: "",
    };
  },
  created() {
    // 获取文章分类列表
    this.getCategoryList();
    this.change();
  },
  methods: {
    change(e) {
		let _this = this
		this.$emit("getValue",{
			id:_this.options[e]['id'],
			end_time:_this.options[e]['end_time'],
			name:_this.options[e]['name'],
			start_time:_this.options[e]['start_time']
		});
    },
    getCategoryList() {
      let _this = this;
      _this.axios
        .get("/api/weishop/admin/market/super/index",{
			params:{
				page:1,
				limit:1000,
				super_type:_this.typelei,
				search_status:'',
				start_time:'',
				end_time:''
			}
		})
        .then((res) => {
          if (res.code == 200) {
            _this.options = res.data.data;
          } else {
            eltips(res.msg, "error");
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-input--suffix .el-input__inner {
  height: 34px;
}
</style>
